import { AnalyticsProperties } from '@modernhealth/analytics-core';
import { ContentLinkFragment } from '../documents/getHomeScreen.generated';

export type ContentTracking = {
    contentIndex?: number;
    eventName?: string;
    props?: { page_section: string; page_section_uuid: string } | { [key: string]: unknown };
    trackClick: (eventName: string, properties?: AnalyticsProperties | undefined) => void;
};

export type SectionType = { title: string; id: string };

type TrackClickContentProps = {
    content_type?: string;
    content_uuid?: string;
    page_section?: string;
    page_section_uuid?: string;
    element_index?: number;
    content_slug?: string | null;
    translation_key?: string;
    content_title?: string;
    button_copy?: string | null;
    link_url?: string;
};

export const getTrackClickCallback = ({
    link,
    props,
    contentIndex,
    eventName = 'content',
    trackClick,
}: ContentTracking & { link: ContentLinkFragment }) => {
    const trackClickContent = (contentProps?: TrackClickContentProps) =>
        trackClick(eventName, {
            element_index: contentIndex || 0,
            ...contentProps,
            ...props,
        });

    switch (link.__typename) {
        case 'MeditationLinkNode':
            return () =>
                trackClickContent({
                    content_type: 'meditation',
                    content_uuid: link.meditation.uuid,
                    content_slug: link.meditation.slug,
                });
        case 'ProgramLinkNode':
            return () =>
                trackClickContent({
                    content_type: 'program',
                    content_uuid: link.program.uuid,
                    content_slug: link.program.slug,
                });
        case 'CourseLinkNode':
            return () =>
                trackClickContent({
                    content_type: 'course',
                    content_slug: link.course.slug,
                });
        case 'ExternalLinkNode':
            return () => trackClickContent({ link_url: link.url });
        case 'InternalLinkNode':
            return () => trackClickContent({ translation_key: link.titleTranslationKey });
        case 'ScreenLinkNode':
            return () =>
                trackClickContent({
                    content_title: link.title,
                });
        case 'CircleSeriesLinkNode':
            return () =>
                trackClickContent({
                    content_type: 'circle series',
                    content_uuid: link.circleSeries?.uuid,
                });
        case 'CircleTopicLinkNode':
            return () =>
                trackClickContent({
                    content_type: 'circle topic',
                    content_uuid: link.circleTopic?.id,
                });
        default:
            return undefined;
    }
};
